import { useLayoutEffect } from "react";
import { Layout } from "../../components/common/Layout"
import { WorkplaceDocumentsTable } from "../../components/medical-checkups/WorkplaceDocumentsTable";

export const WorkplaceDocumentsPage = () => {

    const title = "Направления на подпись";
    useLayoutEffect(() => {
        document.body.style.backgroundColor = "white"
        document.body.style.backgroundImage = "";
    });
    return (
        <Layout title={title}>
            <WorkplaceDocumentsTable />
        </Layout>
    )
}
